<script>
  import {location} from 'svelte-spa-router'
  
  import { token, account } from '$services/stores.js'

  function logout () {
    console.log('logout');
    token.set('')
    account.set('')
  }
</script>

<main id="header">
  <div id="left">
    <div id="logotype">
      <span id="company">WM</span>
      <span id="system">Custom Delivery System</span>
    </div>

    <img src="images/wm_logo.png" alt="0">

    <!-- <div id="breadcrumb"> -->
    <!--   {$location} -->
    <!-- </div> -->
  </div>

  <div id="buttons">
    {#if $account !== ''}
      <!-- <span class="logedas">Logged as <b>{$account}</b></span> -->
      <!-- <i class="space-10"></i> -->
      <button class="button logout" on:click={logout}>Logout</button>
    {/if}
    <!-- <i class="space-10"></i> -->
    <!-- <button class="button docs">API docs</button> -->
    <i class="space-15"></i>
  </div>

</main>

<style lang="scss">
  @import "src/variables.scss";
  
  #header {
    position: fixed;
    top: 0;
    left: 0;

    background-color: #202020;
    height: 5vh;
    width: 100vw;
    z-index: 10000000;

    display: flex;
    justify-content: space-between;

    #left {
      display: flex;

      #logotype {
        @include serif;
        padding-left: 10px;
        display: flex;
        align-items: center;
        font-size: 1.4em;

        #company {
          font-weight: bolder;
          padding-right: 2px;
        }

        #system {
          font-weight: 100;
	  width: 250px;
        }

      }

      #breadcrumb {
        margin-left: 10px;
        display: flex;
        align-items: center;
        font-size: 1.2em;
        color: $gray5;
      }


      img {
        height: 100%;
      }
    }

    #buttons {
      display: flex;
      align-items: center;
      padding-right: 10px;
    }
  }
</style>
